(function () {
  "use strict";

  /* Reveals any [class*="js-animate"] element once it scrolls into view.
     Sections/blocks opt in via their "Scroll animation" setting, which adds
     the js-animate / js-animate--fade-up / js-animate--fade-in classes
     (see snippets/section-style-attrs.liquid and the composable blocks). */

  var targets = document.querySelectorAll(".js-animate");
  if (!targets.length) return;

  if (!("IntersectionObserver" in window)) {
    targets.forEach(function (el) { el.classList.add("is-inview"); });
    return;
  }

  /* threshold MUST stay 0 -- do not raise it.

     It used to be 0.1, meaning "fire once 10% of the element is visible".
     That is a percentage of the ELEMENT's height, not the viewport's, so it
     silently becomes unreachable on any element taller than ~10 viewports:
     10% of a 12,456px Terms of Service section is 1,245px, but the effective
     root (viewport minus the -10% bottom rootMargin) is only ~810px. At most
     ~6.5% of that section could ever intersect, isIntersecting never became
     true, and the section stayed at opacity:0 permanently.

     The result was a completely blank page. Terms of Service and Privacy
     Policy both rendered their full text into the DOM and then never
     revealed it. Shorter pages like Return Policy were unaffected, which is
     what made it look like a content problem rather than an animation one.

     threshold 0 fires as soon as a single pixel crosses, which is correct
     for an element of ANY height. The reveal still reads as a scroll
     animation because rootMargin holds it back until the element is properly
     into the viewport rather than just clipping the edge. */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-inview");
          observer.unobserve(entry.target);
        }
      });
    },
    { root: null, rootMargin: "0px 0px -10% 0px", threshold: 0 }
  );

  targets.forEach(function (el) { observer.observe(el); });

  /* Failsafe: if anything ever prevents the observer from firing -- a
     rendering quirk, a script error further up the page, an element that
     starts taller than the document -- reveal everything still hidden after
     3 seconds rather than leaving content permanently invisible. An
     animation that fails should degrade to "no animation", never to "no
     content". */
  window.setTimeout(function () {
    document.querySelectorAll(".js-animate:not(.is-inview)").forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("is-inview");
    });
  }, 3000);
})();
